import { Toast } from 'antd-mobile';
import { appMethod as app } from '@utils/app';

import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';

import OfficialPage from '../OfficialPage';

import './MyAddress.less';

export default class MyAddress extends OfficialPage {
  state = {
    selectAddressId: '',
    orderId: '',
    addressList: [],
    afterInitial: false,
    isFromBack: false,
    from: '',
    fromAddAdress: false,
    showNewAddressDialog: true,
    address_id: '',
    changeLocal: 0,
    localAddress: '',
    selectProCityDirs: true,
    storeStyle: {

    }
  }
  subShopId = ''

  constructor(props) {
    super(props);
    document.title = '我的地址';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    let selectAddressId = options.id || '',
      orderId = options.oid || '',
      preTakeout = options.preTakeout || '',
      locateAddress = options.locateAddress || '',
      localLatLng = app.globalData.takeoutAddressInfoByLatLng || '',
      from = options.from || ''
    this.syncUserAddress = options.syncUserAddress || ''
    this.locateAddress = locateAddress
    this.setData({
      orderId: orderId,
      preTakeout: preTakeout,
      localAddress: locateAddress,
      localLatLng: localLatLng,
      from: from
    })
    this.selectAddressId = selectAddressId
    this.from = from
    this.subShopId = options.sub_shop_id || ''
    this.getAppECStoreConfig()
    this.getAddressList(selectAddressId, orderId, from)
  }

  componentDidMount() {
    if (this.data.isFromBack) {
      this.getAddressList(this.selectAddressId, this.data.orderId, this.from)
    } else {
      this.setData({
        isFromBack: true
      })
    }
  }

  getAddressList = (selectAddressId, orderId, from) => {
    let that = this
    let shopInfo = app.globalData.takeoutShopInfo
    let addressList = []
    let hasInDistance = true
    app.sendRequest({
      url: '/index.php?r=AppShop/addressList',
      success: function(res) {
        let address = res.data
        for (var i = 0, j = address.length - 1; i <= j; i++) {
          if (from == 'previewtakeout') {
            address[i].is_distance =
              app.calculationDistanceByLatLng(
                shopInfo.latitude,
                shopInfo.longitude,
                address[i].latitude,
                address[i].longitude
              ) < shopInfo.deliver_distance
                ? 1
                : 0
          }
          if (address[i].is_distance == 0) {
            hasInDistance = false
          }
          var addressInfo = address[i].address_info
          var addressAry = [
            (addressInfo.province && addressInfo.province.text) || '',
            (addressInfo.city && addressInfo.city.text) || '',
            (addressInfo.district && addressInfo.district.text) || ''
          ]
          var joinStr = ''
          if (+addressInfo.country.id !== 1) {
            if (addressAry[1] === addressAry[2] || addressAry[2] === '') {
              addressAry.pop()
            }
            joinStr = ' '
          }
          addressAry.push(addressInfo.detailAddress || '')
          addressInfo.addressString = addressAry.join(joinStr)
          addressList.push(address[i])
        }
        if (selectAddressId || orderId || from) {
          that.setData({
            addressList: addressList,
            selectAddressId: selectAddressId || '',
            orderId: orderId || '',
            from: from,
            hasInDistance: hasInDistance
          })
        } else {
          that.setData({
            addressList: addressList,
            hasInDistance: hasInDistance
          })
        }
      }
    })
  }
  addNewAddress = () => {
    app.turnToPage('/addAddress')
  }
  addWechatAddress = () => {
    let _this = this
    app.chooseAddress({
      success: function(res) {
        app.sendRequest({
          method: 'post',
          url: '/index.php?r=AppShop/AddWxAddress',
          data: {
            detailInfo: res.detailInfo || '',
            cityName: res.cityName || '',
            provinceName: res.provinceName || '',
            UserName: res.userName || '',
            telNumber: res.telNumber || '',
            district: res.district || '',
            countyName: res.countyName || ''
          },
          success: function() {
            _this.getAddressList(undefined, undefined, _this.data.from)
          }
        })
      }
    })
  }
  selectAddress = e => {
    var addressId = e.currentTarget.dataset.id,
      that = this,
      pages = app.getCurrentPages(),
      prePage = pages[pages.length - 2],
      addressList = this.data.addressList
    if (!prePage) {
      Toast.info('当前操作需要返回上一页');
      app.turnBack();
      return;
    }
    this.setData({
      selectAddressId: addressId || ''
    })
    for (var i = addressList.length - 1; i >= 0; i--) {
      if (addressList[i].id == addressId) {
        prePage.setData({
          selectAddress: addressList[i],
          selectAddressId: addressList[i].id
        })
        typeof prePage.selectAddressCallback === 'function' &&
        prePage.selectAddressCallback(addressList[i])
      }
    }
    app.turnBack()
  }
  editAddress = e => {
    let dataset = e.currentTarget.dataset
    let addressId = dataset.id
    let countryId = dataset.countryId
    app.turnToPage(
      '/addAddress?id=' +
      addressId +
      '&countryId=' +
      countryId
    )
  }
  getAppECStoreConfig = () => {
    app.getAppECStoreConfig(res => {
      this.setData({
        storeStyle: res.color_config
      })
    }, this.subShopId)
  }

  render() {
    const {
      showGetUserInfo,
      addressList,
      from,
      hasInDistance,
      storeStyle
    } = this.state
    return (
      <div className="official-page my-address">
        <TopNav title="我的地址"/>
        <ScrollView scroll-y="true" style={convertLineStyleData('height: calc(100% - 55px);')}>
          <div
            className="myAddress-wrap page"
            id="myAddress"
            style={convertLineStyleData('height: 100%;')}
          >
            <div
              className="get-wechat-address"
              onClick={this.addWechatAddress}
            >
              <img src="http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/goods-style-wechat.png" />
                <span>获取微信收货地址</span>
                <span className="ico-moon icon-rightarrow"></span>
            </div>
            <div className="myAddress-content-container">
              {!addressList.length ? (
                <React.Fragment>
                  <div style={convertLineStyleData('color:#a8a8a8; padding:20px;')}>暂无收货地址</div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  {addressList.map((item, index) => {
                    return (
                      <React.Fragment key={index}>
                        {((from == 'previewtakeout' && item.is_distance == 1) ||
                          from != 'previewtakeout') && (
                          <div className="myAddress-address">
                            <div
                              className="myAddress-address-top"
                              data-info={item}
                              onClick={
                                from == 'userCenterEle' ? null : this.selectAddress
                              }
                              data-id={item.id}
                            >
                              <div>
                                {item.address_info.label == 0 && (
                                  <label className="home address-label">
                                    家
                                  </label>
                                )}
                                {item.address_info.label == 2 && (
                                  <label className="company address-label">
                                    公司
                                  </label>
                                )}
                                {item.address_info.label == 1 && (
                                  <label className="school address-label">
                                    学校
                                  </label>
                                )}
                                <span className="address-person">
                              {item.address_info.name +
                              ' ' +
                              (item.address_info.sex == 1
                                ? '(先生)'
                                : item.address_info.sex == 0
                                  ? '(女士)'
                                  : '') +
                              ' ' +
                              item.address_info.contact}
                            </span>
                              </div>
                              <span className="address-detail">
                            {item.address_info.addressString}
                          </span>
                            </div>
                            <span
                              className="myAddress-edit ico-moon icon-community-edit"
                              onClick={this.editAddress}
                              data-id={item.id}
                              data-country-id={item.address_info.country.id}
                            ></span>
                          </div>
                        )}
                      </React.Fragment>
                    )
                  })}
                  {from == 'previewtakeout' && !hasInDistance && (
                    <React.Fragment>
                      <div className="address-list-title">
                        以下地址不在配送范围
                      </div>
                      {addressList.map((item, index) => {
                        return (
                          <React.Fragment key={index}>
                            {((from == 'previewtakeout' &&
                              item.is_distance != 1) ||
                              from != 'previewtakeout') && (
                              <div
                                className="myAddress-address"
                                style={convertLineStyleData('background-color: #fdfdfd;')}
                              >
                                <div className="myAddress-address-top">
                                  <div>
                                <span
                                  className="address-detail"
                                  style={convertLineStyleData('color: #999;width:auto;')}
                                >
                                  {item.address_info.province.text +
                                  item.address_info.city.text +
                                  item.address_info.district.text +
                                  item.address_info.detailAddress}
                                </span>
                                  </div>
                                  <span
                                    className="address-person"
                                    style={convertLineStyleData('color: #999;')}
                                  >
                                {item.address_info.name +
                                ' ' +
                                (item.address_info.sex == 1
                                  ? '(先生)'
                                  : item.address_info.sex == 0
                                    ? '(女士)'
                                    : '') +
                                ' ' +
                                item.address_info.contact}
                              </span>
                                </div>
                              </div>
                            )}
                          </React.Fragment>
                        )
                      })}
                    </React.Fragment>
                  )}
                </React.Fragment>
              )}
            </div>
          </div>
        </ScrollView>
        <div
          className="myAddress-bottom-nav"
          style={convertLineStyleData('background:' + storeStyle.theme)}
          onClick={this.addNewAddress}
        >
          新增收货地址
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/my-address/MyAddress.jsx